import { Application } from "pixi.js";
import { FC } from "@flashist/fconsole";

import { Game } from "./Game";

// --- Minimal Adapter Shim for FConsole ---
class Pixi8Adapter {
    constructor(private app: Application) { }
    get ticker() { return this.app.ticker; }
    get renderer() { return this.app.renderer; }
    createDisplayObjectContainerWrapper(nativeObject: any) { return nativeObject; }
}
// Support for legacy global pattern if needed by FConsole
(window as any).EngineAdapter = { instance: null };

/**
 * Entry point for the modern Pixi.js v8 demo.
 * Initializes FConsole with raw Pixi stage.
 */
class Main {

    private _app!: Application;
    private _game!: Game;

    constructor() {
        this.init();
    }

    private async init(): Promise<void> {
        this._app = new Application();

        await this._app.init({
            resizeTo: window,
            backgroundColor: 0x0a0a1a,
            antialias: true
        });

        document.body.appendChild(this._app.canvas);

        //
        this._game = new Game();
        this._app.stage.addChild(this._game.view);

        // Initialize fconsole with raw Pixi stage + shim
        try {
            // Set up the global adapter instance for FConsole
            (window as any).EngineAdapter.instance = new Pixi8Adapter(this._app);

            // Shim the stage with required properties for direct access
            const stageShim: any = this._app.stage;
            stageShim.ticker = this._app.ticker;
            stageShim.renderer = this._app.renderer;

            // @ts-ignore
            FC.startInit(stageShim);
            FC.visible = true;
        } catch (e) {
            console.warn("FConsole initialization failed:", e);
        }

        // Handle window resize
        window.addEventListener("resize", () => this.onResize());

        // Handle FConsole toggle
        window.addEventListener("keydown", (e) => {
            if (e.code === "Backquote") {
                FC.visible = !FC.visible;
            }
        });
    }

    private onResize(): void {
        if (this._game) {
            this._game.onResize();
        }
    }

}

// Start the application
new Main();
